import clsx from 'clsx';

import type { PriorityTier } from '@customTypes/priority-tier';

import StatusPrefix from '@ui-components/layout/StatusPrefix';

import styles from './DataSourceItemTitle.module.css';
import PriorityTierToggle from './PriorityTierToggle';

type Props = {
  active?: boolean;
  className?: string;
  onClick?: () => void;
  onTogglePriorityTier?: () => void;
  priorityTier?: PriorityTier;
  syncStatus?: 'pending' | 'error' | 'complete' | 'unsupported';
  title: string;
};

const DataSourceItemTitle = ({ active, className, onClick, onTogglePriorityTier, priorityTier, syncStatus, title }: Props) => {
  const statusPrefixes = (
    <>
      {syncStatus === 'pending' && active !== false && <StatusPrefix status="processing" />}
      {syncStatus === 'error' && <StatusPrefix status="error" />}
      {syncStatus === 'unsupported' && <StatusPrefix status="unsupported" />}
      {syncStatus === 'pending' && active === false && <StatusPrefix status="pausing" />}
      {active === false && syncStatus !== 'pending' && <StatusPrefix status="paused" />}
    </>
  );

  return (
    <span className={clsx(styles.dataSourceItemTitle, className)}>
      {priorityTier !== undefined && (
        <PriorityTierToggle disabled={syncStatus === 'pending'} priorityTier={priorityTier} onToggle={onTogglePriorityTier} size="small" />
      )}
      {onClick
        ? <button type="button" className={styles.titleButton} onClick={onClick}>{statusPrefixes}<span className={styles.title}>{title}</span></button>
        : <>{statusPrefixes}<span className={clsx(styles.title, styles.titleStandalone)}>{title}</span></>
      }
    </span>
  );
};

export default DataSourceItemTitle;
